export const remittanceMethods = {
  'bank': 'Bank Transfer',
  'mail': 'Registered Mail',
};